export const FIELDS = {
  ID: 'id',
  PICK_TICKET_ID: 'pickTicketId',
  PICK_TICKETS_VIEW_ID: 'pickTicketsViewId',
  INVOICE_LINE_ID: 'invoiceLineId',
  INVENTORY_ID: 'inventoryId',
  INVENTORY_ALLOCATION_ID: 'inventoryAllocationId',
  SERVICE_ORDER_LINE_ID: 'serviceOrderLineId',
  VENDOR_RMALINE_ID: 'vendorRmaLineId',
  QUANTITY_ALLOCATED: 'quantityAllocated',
  QUANTITY_TO_PULL: 'quantityToPull',
  QUANTITY_PULLED: 'quantityPulled',
  PART_NUMBER: 'partNumber',
  PART_NUMBER_CONFIRMED: 'partNumberConfirmed',
  MANUFACTURER_NAME: 'manufacturerName',
  MANUFACTURER_CONFIRMED: 'manufacturerConfirmed',
  DATE_CODE: 'dateCode',
  DATE_CODE_CONFIRMED: 'dateCodeConfirmed',
  LOT_CODE: 'lotCode',
  LOT_CODE_CONFIRMED: 'lotCodeConfirmed',
  REVISION: 'revision',
  REVISION_CONFIRMED: 'revisionConfirmed',
  CONDITION_NAME: 'conditionName',
  CONDITION_CONFIRMED: 'conditionConfirmed',
  COUNTRY_OF_ORIGIN_NAME: 'countryOfOriginName',
  COOCONFIRMED: 'cooConfirmed',
  SELECTED: 'selected',
  CONDITION_ID: 'conditionId',
  COUNTRY_OF_ORIGIN_ID: 'countryOfOriginId',
  WAREHOUSE_ID: 'warehouseId',
  WAREHOUSE_NAME: 'warehouseName',
  LOCATION: 'location',
  DESCRIPTION: 'description',
  CONFIRMED_BY_USER_ID: 'confirmedByUserId',
  CREATED_BY_USER_ID: 'createdByUserId',
  CREATED_BY_USER_FULL_NAME: 'createdByUserFullName',
  MODIFIED_BY_USER_ID: 'modifiedByUserId',
  MODIFIED_BY_USER_FULL_NAME: 'modifiedByUserFullName',
  DATE_CREATED: 'dateCreated',
  DATE_MODIFIED: 'dateModified',
  ACTIVE: 'active',};